// client/src/pages/PrivacyPage.jsx
import React from "react";
import LegalLayout from "./LegalLayout.jsx";
import LegalPageBody from "./LegalPageBody.jsx";

export default function PrivacyPage() {
  return (
    <LegalLayout pageKey="privacy">
      {({ lang }) => <LegalPageBody slug="privacy" lang={lang} />}
    </LegalLayout>
  );
}
